import { RequestHelper } from "../Helpers/RequestHelper.js";

export class PmApiDtm {
    constructor(pmchat) {        
        this.pmchat = pmchat;
    }

    getRootURL() {
        if (this.pmchat.isProduction()) {
            return "https://api.dtm.pixelmotiondemo.com/";
        }
        return "http://pmm-api.loc/";
        // return "https://api.dtm.pixelmotiondemo.com/";
    }

    getURL() {
        return this.getRootURL() + "api/v1/";
    }

    postLead(data, successCallback, errorCallback) {
        let url = this.getURL() + "lead/save/drs";
        this.getIPAddress(
            (response) => {                
                let ip = $this.getIpFromResponse(response);
                data.set("ip", ip);
                RequestHelper.ajax(
                    "POST",
                    url,
                    data,
                    successCallback,
                    errorCallback
                );
            },
            (error) => {
                data.set("ip", "");
            }
        );
    }

    postChatLead(formData, successCallback, errorCallback) {
        var $this = this;
        let url = this.getURL() + "lead/save/chat";
        this.getIPAddress(
            (response) => {                
                const ip = $this.getIpFromResponse(response);
                formData.set("ip", ip);
                RequestHelper.ajax("POST", url, formData, successCallback, errorCallback);
            },
            (error) => {
                data.set("ip", "");
            }
        );
    }

    getIpFromResponse(cloudFlareReponse){
        let ip = cloudFlareReponse
                .split("\n")
                .filter((el) => el.startsWith("ip"))
                .join("\n");
        return ip.substring(3);
    }

    getIPAddress(successCallback, errorCallback) {
        const CLOUDFLARE = "https://www.cloudflare.com/cdn-cgi/trace";
        RequestHelper.ajax(
            "GET",
            CLOUDFLARE,
            {},
            successCallback,
            errorCallback
        );
    }

    getVinDecode(data, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",
            this.getURL() + "crs/" + data.vin,
            {},
            successCallback,
            errorCallback
        );
    }

    getVehicle(vin, successCallback, errorCallback){
        var siteToken = this.pmchat.config.site_token;
        RequestHelper.ajax(
            "GET",
            this.getURL() + "vehicle/" + siteToken + "/" + vin,
            {},
            successCallback,
            errorCallback
        );
    }
}
